import {
  registerCustomDetailComponent,
  registerFormInputComponent,
} from "@vendure/admin-ui/core";
import { CertificationFormComponent } from "./components/certification.form";
import { ProductCertificationsComponent } from "./components/certification-selector/certification-selector.component";
// import { CertificationSelectorComponent } from "./components/certification-selector/certification-selector.component";
export default [
  registerFormInputComponent(
    "certification-input-component",
    CertificationFormComponent,
  ),

  // registerFormInputComponent(
  //   "certification-selector-component",
  //   CertificationSelectorComponent,
  // ),
  //
  registerCustomDetailComponent({
    component: ProductCertificationsComponent,
    locationId: "product-detail",
  }),
];
